// export const mainUrl = "https://commitedcargo.alobhatech.com/";
export const mainUrl = "https://api.flexichains.com/";
// local
// export const adminMainUrl = "http://localhost:4600";
// export const adminMainUrl = "http://localhost:5800";

// dev
// export const adminMainUrl_old = "https://ccargoapi.alobhatech.com";
// export const adminMainUrl = "https://ccargoapi.alobhadev.com";
export const adminMainUrl = "https://api.flexichains.com";



//staging url 
// export const adminMainUrl = "https://cargodev.alobhatech.com";

//live
// export const adminMainUrl = "https://flexichains.com"


//live for committed cargo
// export const adminMainUrl = "https://committedbackend.flexichains.com"


// export const HRMSGOURL = "http://alobhatech.com/hrmsgo";


// staging
// export const adminMainUrl = "https://cargostagging.alobhatech.com";
